export default "__VITE_ASSET__BmKA1FRm__"